/* Circular · Ring 2 product template
   One file, no dependencies, no framework. Reads the variant table Liquid prints
   into the page, keeps the URL and the hidden variant input in sync, and adds the
   ring plus any ticked add-ons in a single /cart/add.js call so the cart drawer
   and every analytics listener see one clean event. */
(function () {
  'use strict';

  function money(cents, format) {
    var v = (cents / 100).toFixed(2);
    if (!format) return v;
    return format.replace(/\{\{\s*amount\s*\}\}/, v)
                 .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
                 .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, v.replace('.', ','));
  }

  function Ring(root) {
    var data = root.querySelector('[data-cx-variants]');
    if (!data) return;
    var cfg = JSON.parse(data.textContent);

    var form      = root.querySelector('[data-cx-form]');
    var idInput   = root.querySelector('[data-cx-variant-id]');
    var priceEl   = root.querySelector('[data-cx-price]');
    var wasEl     = root.querySelector('[data-cx-was]');
    var saveEl    = root.querySelector('[data-cx-save]');
    var atc       = root.querySelector('[data-cx-atc]');
    var msg       = root.querySelector('[data-cx-msg]');
    var stage     = root.querySelector('[data-cx-stage]');
    var thumbs    = root.querySelector('[data-cx-thumbs]');
    var qtyInput  = root.querySelector('[data-cx-qty]');
    var notify    = root.querySelector('[data-cx-notify]');
    var stick     = document.querySelector('[data-cx-stick]');
    var stickP    = stick && stick.querySelector('[data-cx-stick-price]');

    var state = {
      color: cfg.initial.color,
      size:  cfg.initial.size,
      mode:  cfg.initial.size === cfg.kitValue ? 'kit' : 'known'
    };

    function variantFor(color, size) {
      for (var i = 0; i < cfg.variants.length; i++) {
        var v = cfg.variants[i];
        if (v.color === color && v.size === size) return v;
      }
      return null;
    }
    function anyAvailable(color) {
      return cfg.variants.some(function (v) { return v.color === color && v.available; });
    }
    function sizeAvailable(color, size) {
      var v = variantFor(color, size);
      return !!(v && v.available);
    }

    /* ---- rendering ---- */
    function paintSwatches() {
      root.querySelectorAll('[data-cx-color]').forEach(function (b) {
        var on = b.getAttribute('data-cx-color') === state.color;
        b.setAttribute('aria-checked', on ? 'true' : 'false');
        if (anyAvailable(b.getAttribute('data-cx-color'))) b.removeAttribute('data-soldout');
        else b.setAttribute('data-soldout', '');
      });
      var name = root.querySelector('[data-cx-color-name]');
      if (name) name.textContent = state.color;
    }
    function paintSizes() {
      root.querySelectorAll('[data-cx-size]').forEach(function (b) {
        var s = b.getAttribute('data-cx-size');
        b.setAttribute('aria-checked', s === state.size ? 'true' : 'false');
        if (sizeAvailable(state.color, s)) { b.removeAttribute('data-soldout'); b.disabled = false; }
        else { b.setAttribute('data-soldout', ''); b.disabled = true; }
      });
    }
    function paintModes() {
      root.querySelectorAll('[data-cx-mode]').forEach(function (m) {
        var on = m.getAttribute('data-cx-mode') === state.mode;
        m.setAttribute('aria-expanded', on ? 'true' : 'false');
        m.setAttribute('aria-checked', on ? 'true' : 'false');
        m.setAttribute('tabindex', on ? '0' : '-1');
      });
    }
    /* Each media element carries data-colors: a ~-separated list of the finishes whose
       variants use it. Empty means shared (lifestyle, packaging, in-box) and is always
       shown. Picking a finish hides every image that belongs only to another finish,
       which is what the live Replo page does. */
    function ownsColor(el, color) {
      var owners = (el.getAttribute('data-colors') || '').trim();
      if (!owners) return true;                       /* shared: lifestyle, packaging */
      return owners.split('~').filter(Boolean).indexOf(color) > -1;
    }

    /* Media is tagged with the sizes that claim it too, so the gallery keys on the whole
       variant. A photograph claimed only by kit variants (the ring beside the sizing kit)
       is hidden while a real size is selected, and leads the gallery when the kit is. */
    function fitsSize(el) {
      var forKit  = el.getAttribute('data-kit')  === '1';
      var forRing = el.getAttribute('data-ring') === '1';
      if (!forKit && !forRing) return true;           /* unclaimed: always shown */
      return state.mode === 'kit' ? forKit : forRing;
    }

    function paintMedia(v) {
      if (!stage) return;
      var imgs = [].slice.call(stage.querySelectorAll('img'));
      var tbs  = thumbs ? [].slice.call(thumbs.querySelectorAll('button')) : [];

      function keep(el) { return ownsColor(el, state.color) && fitsSize(el); }

      var visible = imgs.filter(keep);
      if (!visible.length) visible = imgs.filter(function (i) { return ownsColor(i, state.color); });
      if (!visible.length) visible = imgs;
      imgs.forEach(function (i) { i.hidden = visible.indexOf(i) === -1; });
      tbs.forEach(function (b) { b.hidden = !keep(b) && visible.length !== imgs.length; });

      /* The selected variant's own photograph leads; otherwise the first one left for
         this colour and size. Selecting the kit therefore opens on the kit shot. */
      var target = null;
      if (v && v.image) target = stage.querySelector('img[data-media-id="' + v.image + '"]');
      /* Prefer a photograph that actually BELONGS to this finish over a shared one.
         Unlabelled images count as shared and show for every finish, so before the alt
         text is filled in one of them can sort first and lead the gallery with the wrong
         ring — which is what put a silver packshot above an Obsidian Black selection. */
      if (!target || target.hidden) {
        var owned = visible.filter(function (el) {
          return (el.getAttribute('data-colors') || '').trim() !== '';
        });
        target = owned[0] || visible[0] || imgs[0];
      }
      if (!target) return;

      imgs.forEach(function (i) { i.classList.toggle('is-on', i === target); });

      /* keep the sticky bar's thumbnail on the same image the gallery is showing */
      var sImg = document.querySelector('[data-cx-stick-img] img');
      if (sImg && target) {
        var ts = target.currentSrc || target.getAttribute('src');
        if (ts && sImg.getAttribute('src') !== ts) {
          /* srcset must go first: while it is present the browser picks from it and
             ignores src entirely, so setting src alone changed nothing on screen. */
          sImg.removeAttribute('srcset');
          sImg.removeAttribute('sizes');
          sImg.setAttribute('src', ts);
          sImg.setAttribute('alt', target.getAttribute('alt') || '');
        }
      }
      var id = target.getAttribute('data-media-id');
      tbs.forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-media-id') === id); });
    }
    /* Keep any size-based add-on (the charger case) on the same size as the ring.
       Matching silently is not enough — the shopper has to SEE that it matched, or they
       will change it themselves and get a case that does not fit. So: match on every
       size change, confirm it in green, and if they deliberately pick a different size,
       leave their choice alone and turn the note into a warning rather than overriding
       them. */
    function syncAddonSizes() {
      var want = String(state.size || '').trim();
      var kitVal = String(cfg.kitValue || '').trim();
      var inKit = state.mode === 'kit' || (kitVal && want.toLowerCase() === kitVal.toLowerCase());
      root.querySelectorAll('select[data-cx-addon-variant]').forEach(function (sel) {
        var hint = sel.parentNode.querySelector('[data-cx-addon-hint]');
        var match = null;
        /* Matching is deliberately tolerant. kit_value is derived per product, so the
           ring may call it "Sizing kit" while the charger calls it "Sizing Kit" or
           "Kit" — an exact, case-sensitive comparison left the case on the old ring
           size after switching to the kit. In kit mode ANY option naming a kit wins;
           otherwise the size is compared without case. */
        for (var i = 0; i < sel.options.length; i++) {
          var o = sel.options[i];
          if (o.disabled) continue;
          var txt = o.text.trim();
          var hit = inKit
            ? txt.toLowerCase().indexOf('kit') > -1
            : txt.toLowerCase() === want.toLowerCase();
          if (hit) { match = o; break; }
        }
        if (!match) { if (hint) hint.hidden = true; return; }   /* no size in common */
        if (!sel.dataset.cxTouched) sel.value = match.value;
        if (!hint) return;
        var picked = sel.options[sel.selectedIndex];
        var ptxt = picked ? picked.text.trim().toLowerCase() : '';
        var same = inKit
          ? ptxt.indexOf('kit') > -1
          : ptxt === want.toLowerCase();
        hint.hidden = false;
        var isKit = inKit;
        if (same) {
          hint.removeAttribute('data-warn');
          hint.textContent = isKit
            ? 'Sizing kit, matched to your order'
            : 'Size ' + want + ', matched to your ring';
        } else {
          hint.setAttribute('data-warn', '');
          hint.textContent = isKit
            ? 'You are ordering a sizing kit — pick the sizing kit case'
            : 'Your ring is size ' + want + ' — this case will not fit it';
        }
      });
    }
    /* Choosing a different ring size — or switching to the sizing kit — supersedes an
       earlier manual pick on the add-on, so the case follows the ring again. Without
       this the flag set by one manual change froze the case forever, which is how a
       size-6 case survived a switch to the sizing kit. */
    function untouchAddons() {
      root.querySelectorAll('select[data-cx-addon-variant]').forEach(function (sel) {
        delete sel.dataset.cxTouched;
      });
    }

    /* THE "WHAT IS IT?" LINK MUST NOT TICK THE ADD-ON (2026-09-01).
       Each add-on row is a <label> wrapping its checkbox, so a click ANYWHERE inside it
       toggles that checkbox — including on a link. Reading the guarantee article would
       therefore also add the guarantee to the basket, silently, which is close to a
       dark pattern and would show up as a refund request.
       Capture phase, so this runs before the label's own activation behaviour:
       stopPropagation keeps the toggle from firing while the anchor still navigates
       normally (no preventDefault — that would kill the link itself).
       The markup side of this pact is data-cx-addon-info in cx-ring-main.liquid.
       Removing either half reintroduces the bug. */
    root.addEventListener('click', function (e) {
      var info = e.target.closest('[data-cx-addon-info]');
      if (!info) return;
      e.stopPropagation();
    }, true);

    /* a manual change is respected until the ring selection changes again */
    root.addEventListener('change', function (e) {
      var sel = e.target.closest('select[data-cx-addon-variant]');
      if (!sel) return;
      sel.dataset.cxTouched = '1';
      syncAddonSizes();
    });

    function paint() {
      var v = variantFor(state.color, state.size);
      paintSwatches(); paintSizes(); paintModes();
      syncAddonSizes();

      if (!v) {
        if (idInput) idInput.value = '';
        atc.disabled = true;
        atc.textContent = cfg.strings.unavailable;
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price, cfg.moneyFormat);
      if (stickP)  stickP.textContent  = money(v.price, cfg.moneyFormat);
      if (wasEl) {
        var show = v.compare > v.price;
        wasEl.hidden = !show;
        if (show) wasEl.textContent = money(v.compare, cfg.moneyFormat);
      }
      if (saveEl) {
        var show2 = v.compare > v.price;
        saveEl.hidden = !show2;
        /* __N__, not '%' — see the note in cx-ring-main.liquid. Math.floor, not round:
           Liquid's integer division floors, so rounding here made the pill change
           number on the first variant switch. Flooring also understates the
           discount rather than overstating it. */
        if (show2) saveEl.textContent = cfg.strings.save.replace('__N__', Math.floor((1 - v.price / v.compare) * 100));
      }
      atc.disabled = !v.available;
      atc.textContent = v.available ? cfg.strings.add : cfg.strings.soldout;
      if (notify) notify.hidden = v.available;
      paintMedia(v);

      var url = new URL(location.href);
      url.searchParams.set('variant', v.id);
      history.replaceState({}, '', url);

      var sv = document.querySelector('[data-cx-stick-variant]');
      if (sv) sv.textContent = [state.color, state.size].filter(Boolean).join(' · ') || 'Select options';
      var sWas = document.querySelector('[data-cx-stick-was]');
      if (sWas) {
        var cmp = v && v.compare > v.price ? v.compare : 0;
        sWas.hidden = !cmp;
        if (cmp) sWas.textContent = money(cmp, cfg.moneyFormat);
      }
      /* The sticky thumbnail is set inside paintMedia now. It used to update only when
         the selected variant carried its OWN featured image — so a finish with no
         assigned image (Gold) left the bar showing the previous ring while the text
         beside it read the new one. */
      var sAtcEl = document.querySelector('[data-cx-stick-atc]');
      if (sAtcEl) sAtcEl.disabled = !v.available;
      var hsa = document.querySelector('[data-cx-hsa]');
      if (hsa) hsa.textContent = money(Math.round(v.price * 0.3), cfg.moneyFormat);

      try { localStorage.setItem('cx:lastVariant:' + cfg.productId, v.id); } catch (err) {}

      root.dispatchEvent(new CustomEvent('cx:variant', { bubbles: true, detail: v }));
    }

    /* ---- input ---- */
    root.addEventListener('click', function (e) {
      var sw = e.target.closest('[data-cx-color]');
      if (sw) { state.color = sw.getAttribute('data-cx-color'); paint(); return; }

      var sz = e.target.closest('[data-cx-size]');
      if (sz && !sz.disabled) { state.size = sz.getAttribute('data-cx-size'); untouchAddons(); paint(); return; }

      var md = e.target.closest('[data-cx-mode]');
      /* the sizing link lives inside the kit card; without this the card swallows the
         click and the shopper never reaches the sizing tool */
      if (md && e.target.closest('a')) return;
      if (md) {
        state.mode = md.getAttribute('data-cx-mode');
        state.size = state.mode === 'kit' ? cfg.kitValue : (cfg.firstNumericSize || state.size);
        untouchAddons();
        paint();
        return;
      }

      var q = e.target.closest('[data-cx-qty-step]');
      if (q && qtyInput) {
        var n = parseInt(qtyInput.value, 10) || 1;
        n = Math.max(1, n + parseInt(q.getAttribute('data-cx-qty-step'), 10));
        qtyInput.value = n;
        return;
      }

      var th = e.target.closest('[data-media-id]');
      if (th && th.tagName === 'BUTTON' && stage) {
        var id = th.getAttribute('data-media-id');
        stage.querySelectorAll('img').forEach(function (i) { i.classList.toggle('is-on', i.getAttribute('data-media-id') === id); });
        thumbs.querySelectorAll('button').forEach(function (b) { b.classList.toggle('is-on', b === th); });
      }
    });

    root.addEventListener('keydown', function (e) {
      var md = e.target.closest && e.target.closest('[data-cx-mode]');
      if (md && (e.key === 'ArrowDown' || e.key === 'ArrowUp' || e.key === ' ' || e.key === 'Enter')) {
        e.preventDefault();
        if (e.key === ' ' || e.key === 'Enter') { md.click(); return; }
        var all = [].slice.call(root.querySelectorAll('[data-cx-mode]'));
        var next = all[(all.indexOf(md) + (e.key === 'ArrowDown' ? 1 : all.length - 1)) % all.length];
        if (next) { next.click(); next.focus(); }
      }
    });

    /* ---- add to cart: ring + ticked add-ons, one request ---- */
    function items() {
      var out = [];
      var id = idInput && idInput.value;
      if (!id) return out;
      out.push({ id: Number(id), quantity: Math.max(1, parseInt(qtyInput ? qtyInput.value : 1, 10) || 1) });
      root.querySelectorAll('[data-cx-addon]:checked').forEach(function (box) {
        var vid = box.getAttribute('data-variant-id');
        var sel = box.closest('.cxp-addon') && box.closest('.cxp-addon').querySelector('select[data-cx-addon-variant]');
        if (sel && sel.value) vid = sel.value;
        var lab = box.closest('.cxp-addon');
        var nm = lab && lab.querySelector('strong');
        /* title travels with the line so a failure can name the product rather than say
           "an extra was unavailable"; post() strips it before sending */
        if (vid) {
          var line = { id: Number(vid), quantity: 1, title: nm ? nm.textContent.trim() : '' };
          /* a subscription product cannot be added without its selling plan */
          var sp = box.getAttribute('data-selling-plan');
          if (sp) line.selling_plan = Number(sp);
          out.push(line);
        }
      });
      return out;
    }

    function say(text, state2) {
      if (!msg) return;
      msg.textContent = text || '';
      if (state2) msg.setAttribute('data-state', state2); else msg.removeAttribute('data-state');
    }

    /* Dawn owns the cart UI. We only need a multi-item add, which Dawn's
       <product-form> cannot do, so we post ourselves and then hand the response
       to the same cart element Dawn would have used. Every app listening on the
       drawer keeps working because the drawer re-renders the normal way. */
    var cartEl = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var spinner = root.querySelector('.loading-overlay__spinner');
    var errWrap = root.querySelector('.product-form__error-message-wrapper');
    var errMsg  = root.querySelector('.product-form__error-message');

    function showError(text) {
      /* One owner. This used to fill Dawn's .product-form__error-message AND our own
         [data-cx-msg], so every failure printed the same sentence twice, stacked.
         Ours is the styled one and already carries role="status" + aria-live, so
         Dawn's is kept permanently empty and hidden. */
      if (errMsg) errMsg.textContent = '';
      if (errWrap) errWrap.setAttribute('hidden', '');
      say(text || '', text ? 'err' : null);
    }

    /* one line at a time, so a sold-out add-on cannot block the ring */
    /* 429 means Shopify is throttling /cart. Retrying immediately makes it worse and is
       what turned one stuck add into every later add failing. */
    var throttledUntil = 0;
    function post(items) {
      if (Date.now() < throttledUntil) {
        return Promise.resolve({ status: 429, _http: 429, description: '' });
      }
      return fetch(cfg.routes.add, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify({ items: items.map(function (i) {
          var o = { id: i.id, quantity: i.quantity };
          if (i.selling_plan) o.selling_plan = i.selling_plan;
          return o;
        }) })
      }).then(function (r) {
        if (r.status === 429) { throttledUntil = Date.now() + 2500; }
        return r.json()
          .then(function (j) {
            /* keep the HTTP code alongside Shopify's body: a synthesised {status} with no
               description was what produced the bare "There was an error" message and
               told nobody anything. */
            if (j && typeof j === 'object') j._http = r.status;
            if (!r.ok && j && !j.status) j.status = r.status;
            return j;
          })
          .catch(function () { return { status: r.status, _http: r.status, description: '' }; });
      });
    }
    function retry() {
      var skipped = [];
      /* A per-item fallback is right for a rejected line, wrong for a throttle: it turns
         one refusal into five more requests. */
      if (Date.now() < throttledUntil) {
        showError('The cart is busy. Give it a moment and try again.');
        return Promise.resolve();
      }
      return post(retry.primary || [])
        .then(function (res) {
          if (res && res.status) {
            /* The ring itself was rejected. Report what Shopify said and try one cart
               re-sync, exactly as the non-add-on path does; throwing a bare Error here
               is what produced the unexplained "There was an error" with add-ons ticked. */
            if (window.console) console.warn('[cx] primary add rejected inside retry', res);
            var e = new Error('primary');
            e.res = res;
            throw e;
          }
          return (retry.extras || []).reduce(function (chain, it) {
            return chain.then(function () {
              return post([it])
                .then(function (r2) {
                  if (r2 && r2.status) {
                    /* keep Shopify's own words: "requires a selling plan", "sold out",
                       and so on. A generic message here hid a real configuration fault. */
                    skipped.push({ it: it, why: r2.description || r2.message || '' });
                    if (window.console) console.warn('[cx] add-on rejected:',
                      it.title || it.id, '->', r2.description || r2.message || r2);
                  }
                })
                .catch(function () { skipped.push({ it: it, why: '' }); });
            });
          }, Promise.resolve());
        })
        .then(function () {
          showError('');
          finishAdd(1, skipped.map(function (s) {
            return { title: s.it.title, why: s.why };
          }));
        })
        .catch(function (err) {
          if (window.console) console.warn('[cx] retry chain failed', err);
          /* carry the response through so the shopper sees the cause, and give the
             stale-token recovery a chance before giving up */
          return recoverOnce((err && err.res) || { description: '', _http: 0 });
        });
    }

    function notifyCart() {
      try { window.postMessage({ type: 'UCART_CHANGED' }, '*'); } catch (err) {}
      document.dispatchEvent(new CustomEvent('cx:added', { bubbles: true }));
      if (window.CXCart && typeof window.CXCart.open === 'function') window.CXCart.open();
    }

    /* A session can end up with a cart token Shopify no longer accepts — every add then
       fails for the whole visit, which is what "impossible to add anything" looks like.
       Re-reading /cart.js re-establishes the token; if the add then works, the shopper
       never sees an error. If it still fails, report the real reason and the HTTP code
       rather than a generic sentence. */
    /* Single completion point. Whatever route the add took — one request, the per-item
       fallback, or a recovery — the drawer is told exactly once, when nothing further
       will change. */
    function finishAdd(okCount, failures) {
      if (failures && failures.length) {
        var names = failures.map(function (f) { return f.title || 'an item'; });
        var why = failures[0].why || '';
        showError(names.join(' and ') + ' could not be added' + (why ? ': ' + why : '.'));
      } else if (okCount) {
        say(cfg.strings.added, 'ok');
        atc.classList.add('is-done');
        setTimeout(function () { atc.classList.remove('is-done'); }, 1600);
      }
      /* No dispatch here. Every early exit — a throttle, a rejected variant, a network
         failure — used to skip this function entirely, so the drawer was told work had
         started and never told it had stopped, and it span forever. The signal now fires
         from addToCart's finally block, which cannot be skipped. */
    }

    var recovered = false;
    function recoverOnce(res) {
      var why = (res && (res.description || res.message)) || '';
      var code = res && res._http ? ' (' + res._http + ')' : '';
      if (res && (res._http === 429 || res.status === 429)) {
        throttledUntil = Date.now() + 2500;
        if (!addToCart.retried) {
          addToCart.retried = true;
          say('One moment\u2026', null);
          setTimeout(function () { addToCart.retried = false; addToCart(); }, 2600);
          return;
        }
        addToCart.retried = false;
        showError('The cart is busy. Give it a few seconds and try again.');
        return;
      }
      if (recovered) { showError(why || ('Could not add to cart' + (code || '') + '. Please reload and try again.')); return; }
      recovered = true;
      if (window.console) console.warn('[cx] add failed, re-syncing cart', res);
      return fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function () { return post(retry.primary || []); })
        .then(function (r2) {
          if (r2 && r2.status) {
            var w2 = (r2.description || r2.message || '');
            showError(w2 || (cfg.strings.error + code));
            return;
          }
          finishAdd(1, null);
        })
        .catch(function (e2) {
          if (window.console) console.warn('[cx] recovery failed', e2);
          showError(why || ('Could not add to cart' + (code || '') + '. Please reload and try again.'));
        });
    }

    function addToCart(e) {
      var list = items();
      if (!list.length) return;
      if (e) e.preventDefault();

      atc.setAttribute('aria-disabled', 'true');
      atc.classList.add('is-busy', 'loading');
      /* Open the drawer at once so the response feels instant, but announce only that
         work has STARTED. The finished result is announced once, at the end, by
         finishAdd() — previously the drawer was told "added" while the fallback was
         still adding items one at a time, so it rendered a guessed number of
         placeholder rows and then stopped refreshing. */
      /* Rate limiting is our problem, not the shopper's. A click during a backoff used to
         be refused outright, which reads as a broken button and pushes people to click
         again — making the throttle worse. Wait out the remaining window and continue
         automatically; the button simply stays busy for a moment. */
      /* Bounded. Without a cap this waited, retried, was throttled again, and waited
         again — the drawer opening and closing in a loop with no way out. Two automatic
         attempts, then hand it back to the shopper. */
      var wait = throttledUntil - Date.now();
      if (wait > 0) {
        addToCart.waits = (addToCart.waits || 0) + 1;
        if (addToCart.waits > 2) {
          addToCart.waits = 0;
          showError('The cart is busy. Give it a few seconds and try again.');
          atc.removeAttribute('aria-disabled');
          atc.classList.remove('is-busy', 'loading');
          return;
        }
        say('One moment\u2026', null);
        setTimeout(function () { addToCart(); }, Math.min(wait + 120, 3000));
        return;
      }
      addToCart.waits = 0;
      document.dispatchEvent(new CustomEvent('cx:adding', { bubbles: true }));
      if (spinner) spinner.remove();
      showError('');

      var primary = list.slice(0, 1);
      var extras  = list.slice(1);
      retry.primary = primary; retry.extras = extras;
      var body = { items: list.map(function (i) {
        var o = { id: i.id, quantity: i.quantity };
        if (i.selling_plan) o.selling_plan = i.selling_plan;
        return o;
      }) };
      /* Deliberately NOT requesting Dawn's sections. Asking for them makes Shopify
         render the theme's cart drawer server-side before /cart/add.js responds, which
         was the several-second wait before the item appeared. Our drawer renders from
         /cart.js and never reads those sections. */

      fetch(cfg.routes.add, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) {
          if (res.status === 429 || /too many/i.test(res.description || '')) {
            throttledUntil = Date.now() + 4000;
            showError('The cart is busy. Give it a moment and try again.');
            return;
          }
          if (extras.length) return retry();
          return recoverOnce(res);
        }
        /* Pixel parity: the shared-cart bridge fires this for the adds it handles, and
           it never sees ours. Fire it here for every line we added. */
        try {
          if (window.fbq) window.fbq('track', 'AddToCart', {
            content_type: 'product',
            content_ids: list.map(function (i) { return String(i.id); }),
            contents: list.map(function (i) { return { id: String(i.id), quantity: i.quantity }; })
          });
        } catch (err) {}

        /* Nudge the Webflow cart badge now rather than waiting for the bridge's
           1.5s poll. The poll still does the Storefront upsert; this only refreshes
           the listener on the marketing site. */
        try { window.postMessage({ type: 'UCART_CHANGED' }, '*'); } catch (err) {}

        /* No redirect and no Dawn render: the drawer opens on cx:added below. Falling
           back to window.location here would navigate away from the product page. */
        finishAdd(list.length, null);
      })
      .catch(function (err) {
        if (extras.length) return retry();
        return recoverOnce({ description: '', message: '', _http: 0, _err: String(err) });
      })
      .finally(function () {
        atc.removeAttribute('aria-disabled');
        atc.classList.remove('is-busy', 'loading');
        /* Unconditional completion signal. Whatever happened above — success, rejection,
           throttle, recovery, network failure — the drawer is told the attempt is over
           and can stop showing a working state. */
        document.dispatchEvent(new CustomEvent('cx:added', { bubbles: true }));
      });
    }
    /* Bind the button directly. We deliberately do NOT listen for form submit: the
       shared-cart bridge claims that event at document capture, so a submit here would
       never reach us and the add-ons would be dropped. The <noscript> submit button in
       the markup is the no-JavaScript fallback and goes through the normal Shopify path. */
    if (atc) atc.addEventListener('click', addToCart);

    /* ---- sticky buy bar ---- */
    if (stick) {
      /* Shopify's draft/preview band is fixed to the bottom of the viewport and would
         otherwise bury the bar. Measure any bottom-pinned bar that is not ours and lift
         by its height. Nothing is found on the published site, so the lift stays 0. */
      var liftBar = function () {
        var lift = 0;
        var vh = window.innerHeight;
        document.querySelectorAll('body > *').forEach(function (el) {
          if (el === stick || el.contains(stick)) return;
          var cs = getComputedStyle(el);
          if (cs.position !== 'fixed' || cs.display === 'none' || cs.visibility === 'hidden') return;
          var r = el.getBoundingClientRect();
          if (!r.height || r.height > 160) return;
          if (Math.abs(r.bottom - vh) > 2) return;   /* must sit ON the bottom edge */
          if (r.width < window.innerWidth * 0.5) return;
          if (r.height > lift) lift = r.height;
        });
        document.documentElement.style.setProperty('--cxp-stick-lift', lift ? lift + 'px' : '0px');
      };
      liftBar();
      window.addEventListener('resize', liftBar);
      setTimeout(liftBar, 1200);
      /* delivery window as a date, not a speed */
      var eta = stick.querySelector('[data-cx-eta]');
      if (eta) {
        var from = new Date(), to = new Date();
        from.setDate(from.getDate() + (cfg.etaMin || 2));
        to.setDate(to.getDate() + (cfg.etaMax || 4));
        var f = function (d) { return d.toLocaleDateString(undefined, { day: 'numeric', month: 'short' }); };
        eta.textContent = 'Arrives ' + f(from) + '–' + f(to);
      }
      /* checkout pill appears once something is in the cart */
      var co = stick.querySelector('[data-cx-stick-co]');
      var coN = stick.querySelector('[data-cx-stick-count]');
      var syncCo = function (known) {
        /* Reuse the cart the drawer already fetched when we have it: this used to add a
           third /cart.js request to every add, which is part of what tripped the rate
           limit on a multi-item add. */
        if (known && typeof known.item_count === 'number') {
          co.hidden = !known.item_count;
          if (coN) coN.textContent = known.item_count ? known.item_count : '';
          return;
        }
        fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); })
          .then(function (c) {
            if (!co) return;
            co.hidden = !c || !c.item_count;
            if (coN) coN.textContent = c && c.item_count ? c.item_count : '';
          }).catch(function () {});
      };
      syncCo();
      addEventListener('message', function (e) {
        if (e && e.data && e.data.type === 'UCART_CHANGED') setTimeout(syncCo, 400);
      });
      /* the drawer broadcasts every cart it receives — no extra request needed */
      document.addEventListener('cx:cart', function (e) { syncCo(e && e.detail); });
    }
    if (stick && atc) {
      var sentinel = root.querySelector('[data-cx-buyrow]');
      if (sentinel && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          var e = es[0];
          /* Desktop: only once the buy row has scrolled ABOVE the viewport, so the bar
             does not duplicate a button that is still on screen.
             Mobile: whenever the buy row is off screen in EITHER direction. The buy
             column is long on a phone — gallery, options, four add-ons — so a bar that
             only appears after passing Add to cart never helps on the way down. */
          var off = !e.isIntersecting;
          stick.classList.toggle('is-on',
            window.innerWidth < 980 ? off : (off && e.boundingClientRect.top < 0));
        }, { threshold: 0 }).observe(sentinel);
      }
      var sAtc = stick.querySelector('[data-cx-stick-atc]');
      if (sAtc) sAtc.addEventListener('click', function () {
        /* Add straight from the bar whenever the current selection resolves to a real,
           available variant — that is the point of the bar being there. Only send the
           shopper up to the options when it does not.
           (state.variant never existed: state holds color/size/mode, so the old check
           was always true and every tap scrolled instead of adding.) */
        var sel = variantFor(state.color, state.size);
        var needsChoice = !sel || !sel.available;
        if (needsChoice && sentinel) {
          var y = sentinel.getBoundingClientRect().top + window.pageYOffset - 140;
          window.scrollTo({ top: y, behavior: 'smooth' });
          return;
        }
        addToCart();
      });
    }

    /* 7. restore the last variant this visitor looked at, unless the URL names one */
    try {
      if (!/[?&]variant=/.test(location.search)) {
        var saved = localStorage.getItem('cx:lastVariant:' + cfg.productId);
        if (saved) {
          var sv2 = cfg.variants.filter(function (x) { return String(x.id) === String(saved) && x.available; })[0];
          if (sv2) { state.color = sv2.color; state.size = sv2.size; state.mode = sv2.size === cfg.kitValue ? 'kit' : 'known'; }
        }
      }
    } catch (err) {}

    paint();
  }

  /* ---- accordions (FAQ, spec groups) ---- */
  function accordions(scope) {
    scope.querySelectorAll('[data-cx-faq]').forEach(function (box) {
      box.querySelectorAll('.cxp-faq__i').forEach(function (item) {
        var q = item.querySelector('.cxp-faq__q');
        var a = item.querySelector('.cxp-faq__a');
        if (!q || !a) return;
        q.addEventListener('click', function () {
          var open = q.getAttribute('aria-expanded') === 'true';
          box.querySelectorAll('.cxp-faq__q[aria-expanded="true"]').forEach(function (o) {
            o.setAttribute('aria-expanded', 'false');
            var oa = o.parentElement.querySelector('.cxp-faq__a');
            if (oa) oa.style.height = '0px';
          });
          if (!open) {
            q.setAttribute('aria-expanded', 'true');
            a.style.height = a.firstElementChild.offsetHeight + 'px';
          }
        });
      });
    });
  }

  /* ---- scroll reveal ----------------------------------------------------
     Same feel as the marketing site: a short rise as each block arrives, and
     children staggered inside a group. Off entirely under reduced motion. */
  function reveal(scope) {
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) {
      scope.querySelectorAll('[data-cx-rise],[data-cx-stagger]').forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    if (!('IntersectionObserver' in window)) {
      scope.querySelectorAll('[data-cx-rise],[data-cx-stagger]').forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    scope.querySelectorAll('[data-cx-rise],[data-cx-stagger]').forEach(function (el) { io.observe(el); });

    /* Figure strips count up once, from their own rendered value, so the markup stays
       the truth and the animation is decoration. */
    var countIo = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        countIo.unobserve(e.target);
        var node = e.target.firstChild;
        if (!node || node.nodeType !== 3) return;
        var raw = node.nodeValue.trim();
        var num = parseFloat(raw.replace(/[^0-9.]/g, ''));
        if (!num || num > 100000) return;
        var dec = (raw.split('.')[1] || '').replace(/[^0-9]/g, '').length;
        var pre = raw.match(/^[^0-9]*/)[0], post = raw.match(/[^0-9.]*$/)[0];
        var t0 = null, dur = 900;
        function step(ts) {
          if (!t0) t0 = ts;
          var p = Math.min(1, (ts - t0) / dur);
          var eased = 1 - Math.pow(1 - p, 3);
          node.nodeValue = pre + (num * eased).toFixed(dec) + post;
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.4 });
    scope.querySelectorAll('.cxp-figs b').forEach(function (b) { countIo.observe(b); });
    scope.querySelectorAll('[data-cx-stagger]').forEach(function (g) {
      [].slice.call(g.children).forEach(function (c, i) { c.style.transitionDelay = (i * 0.055) + 's'; });
    });
  }

  /* ---- parallax on the wide packshots ----------------------------------
     A slow counter-drift as the element crosses the viewport. Transform only, one rAF
     per scroll burst, and it does nothing at all under reduced motion. */
  function parallax(scope) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var els = [].slice.call((scope || document).querySelectorAll('.cxp-ringband__img, [data-cx-par] img'));
    if (!els.length) return;
    var tick = false;
    function frame() {
      tick = false;
      var vh = window.innerHeight;
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        var r = el.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) continue;
        var mid = r.top + r.height / 2;
        var off = ((mid - vh / 2) / vh) * -26;   /* max ~26px either way */
        el.style.transform = 'translate3d(0,' + off.toFixed(1) + 'px,0) scale(1.06)';
      }
    }
    function onScroll() { if (!tick) { tick = true; requestAnimationFrame(frame); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    frame();
  }

  /* ---- size guide drawer — REMOVED 2026-08-21 ---------------------------
     The sizing link now goes straight to sizing.circular.care (client instruction),
     so the drawer that used to intercept the click is gone: its markup, its open/shut
     handlers, its Escape binding and the document-level click listener that watched for
     [data-cx-sizeguide]. The link is a real <a href> in cx-ring-main.liquid now, so it
     middle-clicks, opens in a new tab and is crawlable.
     The .cxp-drawer* CSS in cx-ring.css is kept — nothing else uses it, but it is inert
     and small, and leaving it means the drawer can be restored by reverting one commit. */

  /* ---- ECG demo (12) ----------------------------------------------------
     Rewritten as a dashoffset sweep: the whole trace is built once, then revealed.
     Appending one PQRST complex per frame made the line arrive in visible chunks; a
     dashoffset reveal is continuous. The recording dot is a second copy of the same
     path carrying one round-capped dash, so trace and dot share one measurement and
     cannot drift apart. */
  function ecg(scope) {
    scope.querySelectorAll('[data-cx-ecg]').forEach(function (box) {
      var path = box.querySelector('[data-cx-ecg-path]');
      var timer = box.querySelector('[data-cx-ecg-timer]');
      var result = box.querySelector('[data-cx-ecg-result]');
      var dot = box.querySelector('[data-cx-ecg-dot]');
      var grid = box.querySelector('[data-cx-ecg-grid]');
      var btn = box.querySelector('[data-cx-ecg-run]');
      if (!path || !btn) return;
      var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
      var running = false, raf = 0;
      var SPAN = 1200, STEP = 86, DUR = 13000, SECONDS = 40, GAP = 1400;

      function beat(x) {
        return 'L' + (x + 10) + ' 100L' + (x + 16) + ' 92L' + (x + 22) + ' 108L' +
               (x + 28) + ' 30L' + (x + 34) + ' 170L' + (x + 40) + ' 78L' + (x + 48) + ' 100';
      }
      function build() {
        var d = 'M0 100', rs = [];
        for (var x = 0; x < SPAN; x += STEP) { d += beat(x); rs.push(x + 28); }
        path.setAttribute('d', d);
        if (dot) dot.setAttribute('d', d);
        return rs;
      }
      var rPeaks = build();
      var len = path.getTotalLength ? path.getTotalLength() : 0;

      function showAll() {
        path.style.strokeDasharray = 'none';
        path.style.strokeDashoffset = '0';
        if (dot) dot.style.opacity = '0';
        if (dot) dot.setAttribute('d', path.getAttribute('d') || '');
        if (grid) grid.style.opacity = '1';
        if (timer) timer.textContent = '0:00';
        if (result) { result.hidden = false; result.classList.add('is-in'); }
      }
      if (reduce || !len) { showAll(); btn.addEventListener('click', function () {}); return; }

      function reset() {
        path.style.strokeDasharray = len + ' ' + len;
        path.style.strokeDashoffset = len;
        if (dot) {
          dot.style.strokeDasharray = '0.01 ' + (len + 1);
          dot.style.strokeDashoffset = '0';
          dot.style.opacity = '0';
        }
        if (grid) grid.style.opacity = '0';
        if (result) { result.hidden = true; result.classList.remove('is-in'); }
        if (timer) timer.textContent = '0:' + String(SECONDS).padStart(2, '0');
        box.classList.remove('is-done');
      }
      reset();

      function run() {
        if (running) return;
        running = true;
        reset();
        if (grid) grid.style.opacity = '1';
        var t0 = null;
        function step(ts) {
          if (!t0) t0 = ts;
          var raw = Math.min(1, (ts - t0) / DUR);
          /* Linear on purpose. A real trace advances at a constant paper speed, and the
             ease made it crawl then rush. Linear also keeps the dot exactly on the
             leading edge: with easing, the dot and the revealed stroke were computed
             from the same number but read as out of step through the fast middle. */
          var p = raw;
          var shown = len * p;
          path.style.strokeDashoffset = String(len - shown);

          if (dot) {
            /* one round-capped dash of near-zero length, offset to exactly where the
               trace has been revealed to — identical arithmetic, so no drift */
            dot.style.strokeDashoffset = String(-shown);
            dot.style.opacity = p < 1 ? '1' : '0';
          }
          /* The per-beat card pulse is gone: at fourteen beats it flashed the card border
             continuously, which was distracting rather than alive. The dot's own glow
             already carries the pulse. */
          /* counts DOWN — it is a 40-second recording, not a stopwatch */
          if (timer) timer.textContent = '0:' + String(Math.max(0, Math.round(SECONDS * (1 - p)))).padStart(2, '0');

          if (raw < 1) { raf = requestAnimationFrame(step); return; }
          running = false;
          box.classList.add('is-done');
          if (result) {
            result.hidden = false;
            requestAnimationFrame(function () { result.classList.add('is-in'); });
          }
          /* start over: the reading holds long enough to be read, then repeats */
          clearTimeout(run.loop);
          run.loop = setTimeout(function () { run(); }, GAP + 2600);
        }
        raf = requestAnimationFrame(step);
      }
      btn.addEventListener('click', function () {
        cancelAnimationFrame(raf); clearTimeout(run.loop); running = false; run();
      });
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) {
          if (es[0].isIntersecting) { io.disconnect(); run(); }
        }, { threshold: 0.45 });
        io.observe(box);
      } else { showAll(); }
    });
  }

  /* ---- battery bar (14) ------------------------------------------------- */
  function battery(scope) {
    scope.querySelectorAll('[data-cx-battery]').forEach(function (box) {
      var fill = box.querySelector('[data-cx-bat-fill]');
      if (!fill || !('IntersectionObserver' in window)) { if (fill) fill.style.width = '100%'; return; }
      var io = new IntersectionObserver(function (es) {
        if (!es[0].isIntersecting) return;
        io.disconnect();
        fill.style.width = '100%';
      }, { threshold: 0.4 });
      io.observe(box);
    });
  }

  /* ---- pointer glow (18) + ring arrival (17) ----------------------------
     ⚠ THE RING IS NOT SCROLL-LINKED, AND MUST NOT BE. Do not reintroduce a rAF loop, a
     scroll listener, or a transform written from JS on .cxp-ringband__img.

     Two attempts were made at coupling its rotation to scroll position and both jittered
     on real hardware. The reasons are structural, not tuning problems:

       · a wheel or trackpad delivers coarse, unevenly spaced events, so ANY mapping of
         scroll offset to angle moves in visible jumps between them;
       · scroll handlers run on the main thread, so they compete with layout, image decode
         and the sticky gallery on this page — frames get dropped exactly while scrolling,
         which is precisely when the animation is being watched;
       · the first version also had a CSS transition on the same property JS was writing
         each frame, so the two fought and the transition restarted continuously.

     Replaced with ONE self-contained arrival: the ring rotates and settles down into place
     the first time the band comes into view, then stops. It is a pure CSS animation, so it
     runs on the compositor, is completely decoupled from the scroll event stream, and
     cannot stutter no matter how the page is scrolled. See cxpRingDrop in cx-ring.css.

     Note the direction of the animation: the image's RESTING state is its final state, and
     the class only animates it in FROM an offset. If this observer never fires, the ring is
     simply sitting correctly — it can never be left invisible or mid-rotation. */
  function flourish(scope) {
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    scope.querySelectorAll('[data-cx-glow]').forEach(function (c) {
      c.addEventListener('pointermove', function (e) {
        var r = c.getBoundingClientRect();
        c.style.setProperty('--gx', (e.clientX - r.left) + 'px');
        c.style.setProperty('--gy', (e.clientY - r.top) + 'px');
      });
    });
    var band = scope.querySelector('.cxp-ringband');
    if (band) {
      var seen = new IntersectionObserver(function (es) {
        if (!es[0].isIntersecting) return;
        band.classList.add('is-spun');   /* one-way: the arrival plays once and is done */
        seen.disconnect();
      }, { threshold: 0.25 });
      seen.observe(band);
    }
  }

  function boot() {
    document.querySelectorAll('[data-cx-ring]').forEach(Ring);
    accordions(document);
    reveal(document);
    parallax(document);
    ecg(document);
    battery(document);
    flourish(document);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* Theme editor: re-bind when a section is re-rendered */
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-cx-ring]').forEach(Ring);
    accordions(e.target);
    reveal(e.target);
    parallax(e.target);
    ecg(e.target);
    battery(e.target);
    flourish(e.target);
  });
})();


/* ============================================================================
   Circular · Ring 2 — motion layer (2026-08-22)
   Kept in its own IIFE so it can be removed wholesale without touching the buy
   logic. Everything here is decoration: the page is complete and correct with
   this file's last 200 lines deleted.
   Every effect is skipped under prefers-reduced-motion, and nothing animates a
   control while it is being interacted with.
   ========================================================================== */
(function () {
  'use strict';
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var IO = 'IntersectionObserver' in window;

  function onceInView(el, fn, ratio) {
    if (!IO) { fn(); return; }
    var io = new IntersectionObserver(function (es) {
      if (!es[0].isIntersecting) return;
      io.disconnect();
      fn();
    }, { threshold: ratio || 0.3 });
    io.observe(el);
  }

  /* --- 8, 13, 14 · feature sparklines draw themselves, staggered ---------- */
  function sparklines() {
    var cards = [].slice.call(document.querySelectorAll('.cxp-f13__c'));
    if (!cards.length) return;
    cards.forEach(function (card, i) {
      var p = card.querySelector('.cxp-f13__s path');
      if (!p || !p.getTotalLength) return;
      var len = p.getTotalLength();
      if (!len) return;
      p.style.strokeDasharray = len + ' ' + len;
      p.style.strokeDashoffset = len;
      var loop = card.hasAttribute('data-cx-loop');

      var draw = function (ms) {
        p.style.transition = 'stroke-dashoffset ' + ms + 'ms cubic-bezier(.16,1,.3,1)';
        p.style.strokeDashoffset = '0';
      };
      onceInView(card, function () {
        /* diagonal wave: column position adds to row position, so the grid fills
           from the top-left rather than in flat rows */
        setTimeout(function () {
          card.classList.add('is-lit');
          draw(1100);
          if (loop) {
            /* guided breathing paces forever at six a minute — 10s per cycle */
            setTimeout(function () {
              p.style.transition = 'none';
              card.classList.add('is-breathing');
            }, 1200);
          }
        }, (i % 4) * 90 + Math.floor(i / 4) * 60);
      }, 0.25);

      /* redraw on hover, but never while it is mid-draw */
      card.addEventListener('mouseenter', function () {
        if (loop || !card.classList.contains('is-lit')) return;
        p.style.transition = 'none';
        p.style.strokeDashoffset = String(len);
        void p.getBoundingClientRect();
        draw(750);
      });
    });
  }

  /* --- 10, 22 · numbers count up ----------------------------------------- */
  function countUp(el, done) {
    var raw = (el.textContent || '').trim();
    /* only pure numbers: "6:42" and "4:00" are times and must not be counted */
    var m = raw.match(/^(\d+(?:\.\d+)?)$/);
    if (!m) { if (done) done(); return; }
    var target = parseFloat(m[1]);
    var dp = (m[1].split('.')[1] || '').length;
    var t0 = null, DUR = 900;
    function step(ts) {
      if (!t0) t0 = ts;
      var p = Math.min(1, (ts - t0) / DUR);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = (target * eased).toFixed(dp);
      if (p < 1) requestAnimationFrame(step);
      else { el.textContent = m[1]; if (done) done(); }
    }
    requestAnimationFrame(step);
  }
  function featureNumbers() {
    [].slice.call(document.querySelectorAll('.cxp-f13__c')).forEach(function (card) {
      var v = card.querySelector('.cxp-f13__v');
      if (!v) return;
      var small = v.querySelector('small');
      var unit = small ? small.outerHTML : '';
      var node = document.createTextNode('');
      var num = (v.childNodes[0] && v.childNodes[0].nodeValue || '').trim();
      if (!/^\d+(\.\d+)?$/.test(num)) return;
      onceInView(card, function () {
        var holder = document.createElement('span');
        holder.textContent = '0';
        v.innerHTML = '';
        v.appendChild(holder);
        if (unit) v.insertAdjacentHTML('beforeend', unit);
        holder.textContent = num;
        countUp(holder, function () { card.classList.add('is-counted'); });
      }, 0.35);
    });
  }

  /* --- 15 · gallery cross-fade is CSS; this only guards the first paint --- */
  function gallery() {
    var stage = document.querySelector('[data-cx-stage]');
    if (stage) stage.classList.add('is-anim');
  }

  /* --- 17, 18 · price rolls, save pill pops ------------------------------ */
  function priceMotion() {
    var price = document.querySelector('[data-cx-price]');
    var save = document.querySelector('[data-cx-save]');
    if (price) {
      var last = price.textContent;
      new MutationObserver(function () {
        if (price.textContent === last) return;
        last = price.textContent;
        price.classList.remove('is-roll');
        void price.offsetWidth;
        price.classList.add('is-roll');
      }).observe(price, { childList: true, characterData: true, subtree: true });
    }
    if (save) {
      var wasHidden = save.hidden;
      new MutationObserver(function () {
        if (save.hidden === wasHidden) return;
        wasHidden = save.hidden;
        if (save.hidden) return;
        save.classList.remove('is-pop');
        void save.offsetWidth;
        save.classList.add('is-pop');
      }).observe(save, { attributes: true, attributeFilter: ['hidden'] });
    }
  }

  /* --- 20 · cart badge reacts to an add ---------------------------------- */
  function badgeBounce() {
    document.addEventListener('cx:added', function () {
      var b = document.querySelector('.ucart-badge');
      if (!b) return;
      b.classList.remove('is-bump');
      void b.offsetWidth;
      b.classList.add('is-bump');
    });
  }

  function boot() {
    sparklines();
    featureNumbers();
    gallery();
    priceMotion();
    badgeBounce();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
